
import React, { useContext, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import DataContext from '../context/DataContext';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { FaChevronRight, FaChevronDown } from 'react-icons/fa';
import { useMediaQuery } from 'react-responsive';
import LanguageButton from '../LanguageButton';
import { useTranslation } from 'react-i18next';






const NewNav = () => {
  const { t } = useTranslation();
  
  
    const location = useLocation();
 
    const { auntheticatedUser } = useContext(DataContext);
 
    const lhrcinitiated = ['Admin', 'Operator', 'LHRCstaff'].includes(auntheticatedUser?.role);

  

  const isMobile = useMediaQuery({ query: '(max-width: 969px)' })

  
    const menuConfig = lhrcinitiated
      ? [
          { key: 'home', label: t('Home'), path: '/', icon: 'pi pi-fw pi-home' },
          { key: 'newincident', label: t('New Incident'), path: '/newincident', icon: 'pi pi-fw pi-plus' },
          {
            key: 'unprocessed',
            label: t('Unprocessed'),
            icon: 'pi pi-fw pi-inbox',
            submenu: [
              { key: 'sms', label: t('SMS'), path: '/smsSubmission', icon: 'pi pi-fw pi-whatsapp' },
              { key: 'public', label: t('Public Submissions'), path: '/publicSubmission', icon: 'pi pi-fw pi-users' },
              { key: 'monitor', label: t('Monitor Submissions'), path: '/monitorSubmission', icon: 'pi pi-fw pi-inbox' }
            ]
          },
          {
            label: t('Processed'),
            key: 'processed',
            icon: 'pi pi-fw pi-inbox',
            submenu: [
              { key: 'valid', label: t('Valid Incidents'), path: '/validIncidents', icon: 'pi pi-fw pi-thumbs-up' },
              { key: 'invalid', label: t('Invalid Incidents'), path: '/invalidIncidents', icon: 'pi pi-fw pi-thumbs-down' },
              { key: 'discarded', label: t('Discarded Incidents'), path: '/discardedIncidents', icon: 'pi pi-fw pi-trash' }
            ]
          },
          {
            label: t('Reports'),
            key: 'reports',
            icon: 'pi pi-fw pi-chart-bar',
            submenu: [
              {
                label: t('General Reports'),
                key: 'generalreports',
                submenu: [
                  { key: 'inczone', label: t('Incidents Per Zone'), path: '/inc-zone' },
                  { key: 'incregion', label: t('Incidents Per Region'), path: '/inc-region' },
                  { key: 'incdistrict', label: t('Incidents Per District'), path: '/inc-district' }
                ]
              },
              {
                label: t('Monitors Reports'),
                key: 'monitorsreports',
                submenu: [
                  { key: 'incmntzone', label: t('Incidents Per Zone'), path: '/inc-mnt-zone' },
                  { key: 'incmntregion', label: t('Incidents Per Region'), path: '/inc-mnt-region' },
                  { key: 'incmntdistrict', label: t('Incidents Per District'), path: '/inc-mnt-district' },
                  { key: 'incmntuser', label: t('Incidents Per Monitor'), path: '/inc-mnt-user' }
                ]
              },
              {
                label: t('Valid Incidents Reports'),
                key: 'validincidentsreports',
                submenu: [
                  { key: 'valincbroadcategory', label: t('Per Broadcategory'), path: '/val-inc-broadcategory' },
                  { key: 'valinccategory', label: t('Per Category'), path: '/val-inc-category' },
                  { key: 'valincsubcategory', label: t('Per Subcategory'), path: '/val-inc-subcategory' },
                  { key: 'valincsexvictim', label: t('Per Victim Sex'), path: '/val-inc-sexvictim' },
                  { key: 'valincdisability', label: t('Per Disability'), path: '/val-inc-disability' },
                  { key: 'valincvulnerability', label: t('Per Vulnerability'), path: '/val-inc-vulnerability' },
                  { key: 'valincagegroup', label: t('Per Age Group'), path: '/val-inc-agegroup' },
                  { key: 'valincstatus', label: t('Per Status'), path: '/val-inc-status' },
                  { key: 'valincresponsestatus', label: t('Per Response'), path: '/val-inc-responsestatus' },
                  
                ]
              },
              {
                label: t('Responses&Follow-ups'),
                key: 'responsesfollowups',
                submenu: [
                  { key: 'responseslist', label: t('Responses'), path: '/rpt-responses' },
                  { key: 'followupslist', label: t('Follow-ups'), path: '/rpt-followups' }
                ]
              }
            ]
          },
          { key: 'manuals', label: t('Manuals'), path: '/manuals', icon: 'pi pi-fw pi-file-pdf' },
          { key: 'settings', label: t('Settings'), path: '/settings', icon: 'pi pi-fw pi-cog' }
        ]
      : [
          { key: 'home', label: t('Home'), path: '/', icon: 'pi pi-fw pi-home' },
          { key: 'newincident', label: t('New Incident'), path: '/newincident', icon: 'pi pi-fw pi-plus' },
          {
            label: t('Unprocessed'),
            key: 'unprocessed',
            icon: 'pi pi-fw pi-inbox',
            submenu: [
              { key: 'mysms', label: t('My SMS'), path: '/smsSubmission', icon: 'pi pi-fw pi-whatsapp' },
              { key: 'mysubmissions', label: t('My Submissions'), path: '/monitorSubmission', icon: 'pi pi-fw pi-inbox' }
            ]
          },
          {
            label: t('Processed'),
            key: 'processed',
            icon: 'pi pi-fw pi-inbox',
            submenu: [
              { key: 'validincidents', label: t('Valid Incidents'), path: '/validIncidents', icon: 'pi pi-fw pi-thumbs-up' },
              { key: 'invalidincidents', label: t('Invalid Incidents'), path: '/invalidIncidents', icon: 'pi pi-fw pi-thumbs-down' },
              { key: 'discardedincidents', label: t('Discarded Incidents'), path: '/discardedIncidents', icon: 'pi pi-fw pi-trash' }
            ]
          },
          {
            label: t('Reports'),
            key: 'reports',
            icon: 'pi pi-fw pi-chart-bar',
            submenu: [
              { key: 'myincidents', label: t('My Incidents'), path: '/inc-mnt-user' },
              // { key: 'myvalidincidents', label: 'My Valid Incidents', path: '/val-inc-mnt-user' },
              // { key: 'otherreports', label: 'Other Reports', path: '/inval-inc-mnt-user' }
            ]
          },
          { key: 'manuals', label: t('Manuals'), path: '/manuals', icon: 'pi pi-fw pi-file-pdf' }
        ];
    
    
    
    const [openKeys, setOpenKeys] = useState([]);

    const toggleMenu = (key) => {
      setOpenKeys((prev) =>
        prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
      );
    };
  
    const isActive = (path) => location.pathname === path;
  
    const renderMenuItems = (items, level = 0) => {
     
        return items.map((item, index) => {
        
            const hasSubmenu = !!item.submenu;
        
            const isOpen = openKeys.includes(item.key);
        
            const active = item.path && isActive(item.path);
  
    
            
            const itemStyle = {
                backgroundColor: '#f8f9fa',
                padding: '10px 5px 10px 15px',
                border: '.5px solid #dee2e6',
                fontWeight: 500,
                color: active ? '#41A6D7' : 'black',
                cursor: 'pointer',
                
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                
            }

            const itemStylehassubmenu = {
                backgroundColor: '#f8f9fa',
                padding: '10px 5px 10px 15px',
                border: '.5px solid #dee2e6',
                fontWeight: 500,
                color: active ? '#41A6D7' : 'black',
                cursor: 'pointer',
           
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                borderRadius: (index === 0 && !hasSubmenu && level === 0) ?
                    '5px 5px 0 0' : (index === items.length - 1 && !hasSubmenu && level === 0) ?
                    '0 0 5px 5px' : '0'
                
            }


  
        return (
          
            <div key={item.key}>
            
            <div
              style={hasSubmenu ?itemStyle:itemStylehassubmenu}
              onClick={() => {
                if (hasSubmenu) toggleMenu(item.key);
              }}
            >
              {hasSubmenu && (
                    <span style={{ width: '12px' }}>
                    {isOpen ? <FaChevronDown /> : <FaChevronRight />}
                    </span>
                    )} 
              
              {item.path ? (
                 <Link       
                  to={item.path}
                   style={{
                    textDecoration: 'none',
                    color: active ? '#41A6D7' : 'black',
                    fontWeight: active ? 'bold' : 'normal'
                  }}
                >
                           
                  <i className={item.icon || ''}></i>
                  <span className='ml-2'>{item.label}</span>
                </Link>
              ) : (
                <span className='ml-2'>{item.label}</span>
              )}
            </div>
            {hasSubmenu && isOpen && (
              <div style={{ marginLeft: '8px' }}>
                {renderMenuItems(item.submenu, level + 1)}
              </div>
            )}
          </div>
        );
      });
    };
  
    

    const newnavstyle = {
        position: 'sticky',
        top: 0,
        gridColumn: 1,
        gridRow: '1 / span 3', 
        backgroundColor: '#fff',
        color: '#343a40',
        height: '100vh', 
        overflowY: 'auto', 
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        paddingTop: '5px',
        paddingLeft: '25px',
        paddingRight: '25px'

    }

  const newnamenublockstyle = {
    display: 'block',
    width: '100%',
    margin: 0,
      marginTop: '30px',
    padding: '70px 0px'
    
  }
  const newnavmenublockstyleMobile = {
    display: 'block',
    width: '100%',
    margin: 0,
    marginTop: '0px',
    padding: '10px 0px'
  }

  const newnavmenustyle = {
    backgroundColor: '#f8f9fa',
    padding: '12px 5px 12px 15px',
    border: '.5px solid #dee2e6',
    fontWeight: 500
  } 
    return (
      <div style={newnavstyle}>
      
        <div style={isMobile ? newnavmenublockstyleMobile : newnamenublockstyle}>
           {renderMenuItems(menuConfig)}
            </div>
            
        <div>
        <LanguageButton />
        </div>
            <div className={isMobile ? 'nativenavhelp mt-0':'nativenavhelp mt-3'}>
        <Card className='m-0 p-0'>
          <div className='text-center'> <i className="pi pi-question-circle" style={{ fontSize: '2rem', marginRight: '0.5rem' }}></i></div>
          <div className="m-0">
            <div className='text-center'>{t('Need Help?')}, {t('call Niku')}</div>
            <div className='text-center mt-2'>
              <Button
                label="0767 644 818" 
                severity="secondary"
                icon="pi pi-phone"
                outlined
                disabled
              />
            </div>
          </div>
        </Card>
      </div>
            
    </div>
  );
};

export default NewNav;
